import { render } from "./PageHeader.vue?vue&type=template&id=67600f76"
const script = {}
script.render = render

export default script